.message {
    white-space: pre;
}
